<template>
  <div>
    <div>
      <v-menu
        ref="menu"
        v-model="menu"
        :close-on-content-click="false"
        transition="scale-transition"
        offset-y
        min-width="auto"
      >
        <template v-slot:activator="{ on, attrs }">
          <v-text-field
            :value="formatedDate"
            label="Data de nascimento *"
            prepend-icon="mdi-calendar"
            readonly
            v-bind="attrs"
            v-on="on"
          ></v-text-field>
        </template>
        <v-date-picker
          locale="pt-BR"
          v-model="date"
          :active-picker.sync="activePicker"
          :max="new Date().toISOString().substr(0, 10)"
          min="1950-01-01"
          @change="save"
        ></v-date-picker>
      </v-menu>
    </div>
    <v-text-field disabled label="Idade" :value="age"></v-text-field>
  </div>
</template>

<script>
import { format, formatDistanceToNowStrict } from 'date-fns';
import { ptBR } from 'date-fns/locale';

export default {
  data: () => ({
    activePicker: null,
    date: '', // Initialize as an empty string
    menu: false,
  }),
  props: {
    dateOfBirth: {
      type: [Date, String],
      required: false,
    },
  },
  watch: {
    menu(val) {
      val && setTimeout(() => (this.activePicker = 'YEAR'));
    },
    dateOfBirth(newDate) {
      if (newDate instanceof Date) {
        this.date = newDate.toISOString().substr(0, 10); // Convert to YYYY-MM-DD
      } else if (typeof newDate === 'string' && newDate.trim() !== '') {
        this.date = newDate.substr(0, 10); // Trim to YYYY-MM-DD if it's a full ISO string
      } else {
        this.date = ''; // Reset to an empty string if invalid
      }
    },
  },
  methods: {
    save(date) {
      if (date) {
        this.date = new Date(date).toISOString().substr(0, 10); // Convert to YYYY-MM-DD
        this.$emit('update:dateOfBirth', this.date); // Emit the ISO string
        this.$emit('dateChanged');
      } else {
        this.date = ''; // Reset to an empty string if no date is selected
      }
      this.menu = false; // Close the menu after saving
    },
  },
  computed: {
    age() {
      return this.date
        ? formatDistanceToNowStrict(new Date(this.date), { locale: ptBR, roundingMethod: 'floor' }) // Parse ISO string to Date
        : '';
    },
    formatedDate() {
      if (!this.date) return ''; // Return an empty string if date is null or empty

      try {
        // Parse the date string manually to avoid time zone issues
        const [year, month, day] = this.date.split('-').map(Number); // Split into components
        const parsedDate = new Date(year, month - 1, day); // Construct a local Date object

        if (isNaN(parsedDate.getTime())) {
          console.warn('formatedDate - Invalid date:', this.date); // Debugging
          return ''; // Return an empty string if date is invalid
        }

        return format(parsedDate, 'dd/MM/yyyy'); // Format the date
      } catch (error) {
        console.error('Error formatting date:', error);
        return ''; // Return an empty string if formatting fails
      }
    },
  },
};
</script>
